// extracted by mini-css-extract-plugin
export default {"page":"LoginCRMPage_page__piRoR","limit":"LoginCRMPage_limit__7Zqvd","title":"LoginCRMPage_title__T9fmw"};